import styled from 'styled-components';
import { Text } from '@zillow/constellation';

const MARKER_WIDTH_IN_PX = 80;

interface MarkerProps {
  numPixelsFromLeft: number;
}

export const Marker = styled('div')<MarkerProps>`
  position: relative;
  left: ${(props) => props.numPixelsFromLeft}px;
  width: ${MARKER_WIDTH_IN_PX}px;
  text-align: center;
`;

export const Line = styled.div`
  border: 1px solid #d1d1d5;
  margin-bottom: 10px;
  margin-left: ${MARKER_WIDTH_IN_PX / 2}px;
  margin-right: ${MARKER_WIDTH_IN_PX / 2}px;
`;

export const Flex = styled.div`
  display: flex;
`;

export const Left = styled.div`
  text-align: left;
  width: 50%;
  margin-left: ${MARKER_WIDTH_IN_PX / 2}px;
`;

export const Right = styled.div`
  text-align: right;
  width: 50%;
  margin-right: ${MARKER_WIDTH_IN_PX / 2}px;
`;

export const Zestimate = styled(Text)`
  background-color: #f1f1f4;
  border-radius: 23px;
  padding-left: 12px;
  padding-right: 12px;
`;
